import type TimeTravelCapturer from "../../apps/wp-table-builder/src/store/time-travel/capturer";

export const {
  notify,
  updateNotification,
  parseTable,
  createNewTable,
  cloneBlock,
  insertInnerBlock,
  removeBlock,
  TimeTravel,
  BuilderCtx,
  getRepairedTableHtml,
} = WPTB.utils;

export type TimeTravelCapturerType = typeof TimeTravelCapturer.prototype;
